/* ------------ TABLE CONFIGURATION ------------ */

export interface QuestionnaireMmas8 {
  position: number;
  question: string;
}

export const Q_MMAS_8: QuestionnaireMmas8[] = [
  {
    position: 1, question: 'Qualche volta dimentica di prendere la pillola per '
  },
  {
    position: 2, question: 'Nelle ultime 2 settimane, ci sono stati dei giorni in cui non ha preso le medicine per ',
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Ha mai ridotto o smesso di prendere le medicine senza dirlo al suo medico, perchè si sentiva male quando le prendeva?',
  },
  {
    position: 4, question: 'Quando viaggia o esce di casa, a volte si dimentica di portare con sé i farmaci?',
  },
  {
    position: 5, question: 'Ha preso ieri le sue medicine per '
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 6, question: 'Quando sente che la sua malattia (es. pressione sanguigna) è sotto controllo, a volte smette di prendere le sue medicine?',
  },
  {
    position: 7, question: 'L\'assunzione quotidiana dei farmaci è un vero e proprio disagio per alcune persone.' +
      'Si sente mai infastidito o sente di avere delle difficoltà ' +
      'nell\'attenersi al piano di trattamento della sua malattia (es. pressione sanguigna)?'
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 8, question: 'Le capita di avere difficoltà a ricordarsi di prendere tutti i suoi farmaci per la sua malattia?',
  },
];


export class MMAS8Results {
  doctorID: string;
  patientSSN: string;
  results: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }
}
